import {AnyAction, Dispatch} from '@modifi/redux'
import {createSelector} from 'reselect'

import {rootSelector} from '../../../../../redux/root-selector'

type BuyerView = {
  showBuyerForm: boolean
  editBuyerWithId: string | null | undefined
}

const ACTION_SHOW_BUYER_FORM = 'pages/preunderwriting/buyers/SHOW_BUYER_FORM'
const ACTION_HIDE_BUYER_FORM = 'pages/preunderwriting/buyers/HIDE_BUYER_FORM'

const initialState: BuyerView = {
  showBuyerForm: false,
  editBuyerWithId: null,
}

export default (state = initialState, {type, payload}: AnyAction): BuyerView => {
  switch (type) {
    case ACTION_SHOW_BUYER_FORM: {
      const {buyerId} = payload
      return {
        ...state,
        showBuyerForm: true,
        editBuyerWithId: buyerId,
      }
    }
    case ACTION_HIDE_BUYER_FORM:
      return {
        ...state,
        showBuyerForm: false,
        editBuyerWithId: null,
      }
    default:
      return state
  }
}

export const aHideBuyerForm = (): AnyAction => ({
  type: ACTION_HIDE_BUYER_FORM,
})

export const aShowBuyerForm =
  (buyerId?: string | null | undefined) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: ACTION_SHOW_BUYER_FORM,
      payload: {buyerId},
    })
  }

const baseSelector = createSelector(
  rootSelector,
  root => root?.pages?.preUnderwriting?.buyerDetails?.view
)

export const selectIsBuyerFormVisible = createSelector(baseSelector, view => view.showBuyerForm)

export const selectBuyerId = createSelector(baseSelector, view => view.editBuyerWithId)
